var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineMirror(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A3442999-BC89-4F06-A36D-49896F51B16C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Essetional",
    transform: "translate(-236.000000, -636.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mirror",
    transform: "translate(236.000000, 636.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.25,10 C3.25,5.17999983 7.17000008,1.25 12,1.25 C16.8299999,1.25 20.75,5.17999983 20.75,10 C20.75,14.8200002 16.8299999,18.75 12,18.75 C7.17000008,18.75 3.25,14.8200002 3.25,10 Z M4.75,10 C4.75,14 8,17.25 12,17.25 C16,17.25 19.25,14 19.25,10 C19.25,6 16,2.75 12,2.75 C8,2.75 4.75,6 4.75,10 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,22.75 C5.59,22.75 5.25,22.41 5.25,22 C5.25,21.59 5.59,21.25 6,21.25 L18,21.25 C18.41,21.25 18.75,21.59 18.75,22 C18.75,22.41 18.41,22.75 18,22.75 L6,22.75 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMirror);
export default __webpack_public_path__ + "static/media/vuesax-outline-mirror.087b877c2c80c089c92c89a8b259dce4.svg";
export { ForwardRef as ReactComponent };